import { ToggleButton, ToggleButtonProps } from '@mui/material';
import React, { FormEvent } from 'react';
import { useSlate } from 'slate-react';
import { isMarkActive } from '../../helpers';
import { toggleMark } from '../../transformers';
import { MarkType } from '../../types';

// Mark elements with formattings (bold, italic, etc.)
type MarkButtonProps = { markType: MarkType } & ToggleButtonProps;
export const MarkButton = ({
	markType,
	value = markType,
	children,
	...props
}: MarkButtonProps) => {
	const editor = useSlate();

	const handleMouseDown = (event: FormEvent<HTMLButtonElement>) => {
		event.preventDefault();
		toggleMark(editor, markType);
	};

	return (
		<ToggleButton
			size='small'
			value={value}
			selected={isMarkActive(editor, markType)}
			onMouseDown={handleMouseDown}
			{...props}
		>
			{children}
		</ToggleButton>
	);
};
